<template>
    <div>
        <MenuAccount_Main/>
        <AccountSetting/>
    </div>
</template>

<script>

import MenuAccount_Main from '@/components/menuadmin/account/accountheader/MenuAccount_Main.vue'
import AccountSetting from '@/components/menuadmin/account/accountsetting/AccountSetting.vue'
export default {
    name:'accountSetting',
    components:{
        MenuAccount_Main,
        AccountSetting,
    },
}
</script>